export default __webpack_public_path__ + "static/media/2788.76c279e7.svg";